import type { LandingResponse } from '@/types/landing'
import axios from 'axios'

export const getLandingContentCall = async (
  abortController?: AbortController,
): Promise<LandingResponse> => {
  const { data } = await axios.get('/landing/content', {
    signal: abortController?.signal,
  })
  return data.data
}

// export const getDocumentItemCall = async (
//   abortController?: AbortController,
//   params?: { id: string }
// ): Promise<LandingResponse> => {
//   const { data } = await axios.get(`/documents/${params?.document}`, {
//     signal: abortController?.signal,
//   })
//   return data
// }
